<template>
  <div class="page-detail orders-service-detail" v-loading="loading">
    <div class="title">
      订单详情
      <div class="top-money-container" v-if="isEdit">
        <span class="top-money">
          个人账户余额:
          <span class="money-detail">{{olderMoney.person}}</span>元
        </span>
        <span class="top-money">
          基础补助余额:
          <span class="money-detail">{{olderMoney.grant}}</span>元
        </span>
      </div>
    </div>
    <div class="content">
      <div class="info-block order-info">
        <div class="title">
          订单编号：{{order.code}}
          <span class="state">{{getOrderStateName(order.status)}}</span>
        </div>
        <div class="sub-info">
          <div class="field">
            <div class="label">下单时间</div>
            <div class="text">{{Utils.dateFormat(order.createTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div class="label">接单时间</div>
            <div class="text">{{Utils.dateFormat(order.dispathTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div class="label">下单人</div>
            <div class="text">无</div>
          </div>
          <div class="field">
            <div class="label">开始服务时间</div>
            <div class="text">{{Utils.dateFormat(order.serviceTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div class="label">完成时间</div>
            <div class="text">{{order.finishTime||'--'}}</div>
          </div>
          <div class="field">
            <div class="label">服务人员</div>
            <div class="text">{{order.servicePersonalName}}</div>
          </div>
          <!-- <div class="field">
            <div class="label">操作日志</div>
            <div class="text">无</div>
          </div>-->
        </div>
      </div>
      <div class="info-block service-target">
        <div class="title">服务对象信息</div>
        <div class="sub-info row">
          <div class="field">
            <div class="label">老人信息</div>
            <div class="text">
              <div class="field">
                <div class="label">姓名</div>
                <div class="text">{{info.name}}</div>
              </div>
              <div class="field">
                <div class="label">手机号</div>
                <div class="text">{{info.phone}}</div>
              </div>
              <div class="field">
                <div class="label">身份证</div>
                <div class="text">{{info.idCard}}</div>
              </div>
              <div class="field">
                <div class="label">年龄</div>
                <div class="text">{{info.age}}</div>
              </div>
              <div class="field">
                <div class="label">性别</div>
                <div class="text">{{info.gender|sexFilter}}</div>
              </div>
              <div class="field">
                <div class="label">老人类型</div>
                <div class="text">{{getNameOfOldManType(info.type)}}</div>
              </div>
              <div class="field">
                <div class="label">地址</div>
                <div class="text">{{info.residenceAddress}}</div>
              </div>
              <div class="field">
                <div class="label">标签</div>
                <div class="text">{{info.tagNames}}</div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="label">子女信息</div>
            <div class="text">
              <div class="field" v-for="item in contacts" :key="item.Gid">
                <div class="label">{{item.name}}</div>
                <div class="text">
                  <span>{{item.relationship}}</span>
                  <span>{{item.phone}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-block service-info">
        <div class="title">服务信息</div>
        <div class="sub-info">
          <div class="field">
            <div class="label"></div>
            <div class="text">
              <el-button size="mini" type="primary" @click="saveEdit" v-if="isEdit">保存</el-button>
              <el-button size="mini" plain v-if="isEdit" @click="cancleEdit">取消</el-button>
              <el-button
                size="mini"
                type="primary"
                @click="editOrder"
                v-if="(!isEdit)&&(order.status===1||order.status===2||order.status===3||order.status===4)"
              >编辑</el-button>
            </div>
          </div>
          <div class="field">
            <div class="label">服务商</div>
            <div class="text">
              <p class="service-business-info">
                <span>{{order.serviceProviderName}}</span>
                <span>地址：{{order.address}}</span>
                <span>电话：{{order.cTelPhone}}</span>
              </p>
            </div>
          </div>
          <div class="field">
            <div class="label">服务项目</div>
            <div class="text">
              <p>{{order.serviceItemSkuInfos && order.serviceItemSkuInfos[0] && order.serviceItemSkuInfos[0].ServiceItemName}}</p>
            </div>
          </div>
          <div class="field">
            <div class="label">服务规格</div>
            <div class="text">
              <table
                class="has-selected"
                :class="{disabled: true}"
                v-if="(service.skus || service.Skus || []).length"
              >
                <tbody>
                  <tr
                    v-for="sku in (service.skus || service.Skus || [])"
                    :class="{selected: true}"
                    :key="sku.gid"
                  >
                    <td></td>
                    <td>{{sku.Name || sku.name || sku.ServiceItemSkuName || sku.serviceItemSkuName}}</td>
                    <td>{{sku.Price || sku.price}}</td>
                    <td v-if="isEdit">
                      <el-input-number size="mini" v-model="serviceNum" :min="1" :max="200"></el-input-number>
                    </td>
                    <td v-else>
                      <span>×{{serviceNum}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="field" v-if="isEdit">
            <div class="label">还需支付</div>
            <div class="text">{{addMoney}}元</div>
          </div>
          <div class="field">
            <div class="label">服务单位</div>
            <div class="text">{{service && getNameOfUnitTime(service.unitOfTime)}}</div>
          </div>
          <div class="field">
            <div class="label">服务时长</div>
            <div class="text">{{service && service.unitFrequencyTime}}</div>
          </div>
          <div class="field">
            <div class="label">服务周期</div>
            <div class="text">{{service && service.cycle|cycleFilter}}</div>
          </div>
          <div class="field">
            <div class="label">服务次数</div>
            <div class="text">{{service && service.frequency}}</div>
          </div>
          <div class="field">
            <div class="label">基础补贴支付</div>
            <div class="text">{{order.grantPayment}}元</div>
          </div>
          <div class="field">
            <div class="label">个人钱包支付</div>
            <div class="text">{{order.personPayment}}元</div>
          </div>
        </div>
        <div class="sub-info">
          <div class="field">
            <div class="label">服务时间</div>
            <div class="text" v-if="isEdit">
              <service-time-selector :times="times" :source-object="remark"></service-time-selector>
            </div>
            <div class="text" v-else>预约时间 {{remark.date}}&nbsp;{{remark.time}}</div>
          </div>
          <div class="field">
            <div class="label">服务地址</div>
            <div class="text">{{info.residenceAddress}}</div>
          </div>
          <div class="field">
            <div class="label">联系电话</div>
            <div class="text">{{remark.tel}}</div>
          </div>
          <div class="field">
            <div class="label">备注</div>
            <div class="text" v-if="isEdit">
              <el-input type="textarea" v-model="remark.remark"></el-input>
            </div>
            <div class="text" v-else>{{remark.remark}}</div>
          </div>
        </div>
      </div>
      <div class="info-block service-target">
        <div class="title">订单服务记录</div>
        <div style="padding:10px 15px;">
          <AutoTable
            :columns="allTableObj.columns"
            :dataList="allTableObj.dataList"
            :options="allTableObj.options"
            :tableSize="tableSize"
            :showExpand="showExpand"
            :loadObj="allTableObj.loadObj"
            :operationColumn="allTableObj.operationColumn"
            :fenyeObj="allTableObj.fenyeObj"
            @dataSizeChange="handleSizeChange($event,allTableObj)"
            @dataCurrentChange="handleCurrentChange($event,allTableObj)"
          ></AutoTable>
        </div>
      </div>
    </div>
    <div class="actions">
      <el-button type="primary" size="small" v-if="order.status === 3" @click="startService">开始服务</el-button>
      <el-button type="success" size="small" v-if="order.status === 4" @click="endService">结束服务</el-button>
      <el-button type="danger" size="small" v-if="order.status < 4" @click="cancelOrder">取消订单</el-button>
    </div>
    <el-dialog :visible.sync="showRecord" title="记录详情" center :append-to-body="true">
      <el-form labelWidth="150px" labelPosition="right">
        <el-form-item label="订单编号">
          <span>{{oneRecord.orderCode}}</span>
        </el-form-item>
        <el-form-item label="服务人员">
          <span>{{oneRecord.servicePersonalName}}</span>
        </el-form-item>
        <el-form-item label="订单记录完成时间">
          <span>{{oneRecord.createTime}}</span>
        </el-form-item>
        <el-form-item label="订单记录完成照片">
          <div style="display:flex;flex-flow:row">
            <viewer v-for="(item,index) in oneRecordImgs" :key="index">
              <img :src="item" class="avatar" style="margin-right:20px" />
            </viewer>
          </div>
        </el-form-item>
        <el-form-item label="订单记录完成备注">
          <span>{{oneRecord.remark}}</span>
        </el-form-item>
        <el-form-item label="订单是否异常">
          <span>{{oneRecord.abnormalFinish}}</span>
        </el-form-item>
        <el-form-item label="订单异常备注">
          <span>{{oneRecord.abnormalFinishRemark}}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showAddAbnormal" center title="添加订单异常备注">
      <el-form labelWidth="150px" labelPosition="right" size="mini">
        <el-form-item label="订单异常备注">
          <el-input type="textarea" clearable v-model="abnormalfinishremark"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-button type="primary" @click="saveAbnormal">提交</el-button>
          <el-button @click="()=>{this.showAddAbnormal=false}">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Promise from "promise";
import qs from "qs";
import { addOrderAbnormal, updateOrderApi } from "@/services/all-api.js";
import ServiceTimeSelector from '@/components/partial/ServiceTimeSelector'
export default {
  components: {
    ServiceTimeSelector
  },
  data() {
    return {
      addMoney: null,
      olderMoney: {
        person: 0,
        grant: 0,
        fund: 0
      },
      times: ['08:00-12:00', '12:00-14:30', '14:30-18:00'],
      isEdit: false,
      serviceNum: 0,
      originNum: 0,
      originRemark: '',
      originTime: "",
      originDate: "",
      oneRecordImgs: [],
      orderRecordGid: "",
      abnormalfinishremark: "",
      showAddAbnormal: false,
      oneRecord: {},
      showRecord: false,
      showExpand: true,
      tableSize: "mini",
      loading: false,
      order: {},
      info: {},
      contacts: [],
      service: {},
      remark: {},
      theOrderHistory: [],
      allTableObj: {
        columns: [
          {
            prop: "num",
            label: "#",
            width: "50px",
            align: "center"
          },
          {
            prop: "orderCode",
            label: "订单编号",
            align: "center"
          },
          {
            prop: "servicePersonalName",
            label: "服务人员",
            align: "center"
          },
          {
            prop: "createTime",
            label: "订单记录完成时间",
            align: "center"
          }
        ],
        dataList: [],
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead
        },
        loadObj: {
          isLoading: false
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        logoutDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "200px",
          btns: [
            {
              size: "mini",
              icon: "el-icon-tickets",
              type: "text",
              style: "font-size:16px",
              disabled: false,
              method: (index, row) => {
                this.handleDetail(index, row);
              }
            },
            {
              size: "mini",
              icon: "el-icon-edit",
              type: "text",
              style: "font-size:16px;color:#F56C6C",
              disabled: false,
              method: (index, row) => {
                this.addAbnormal(index, row);
              }
            }
          ]
        },
        fenyeObj: {
          showPage: true,
          currentPage: 1,
          pageSize: 20,
          layoutString: "total,sizes,prev,pager,next,jumper",
          total: 0
        },
        currentTab: "all",
        searchObj: {}
      }
    };
  },
  computed: {
    gid() {
      return this.$route.query.gid;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    editOrder() {
      this.isEdit = true
    },
    saveEdit() {
      let remark = [this.remark.date + ',' + this.remark.time || '', this.info.residenceAddress || '', this.remark.tel || '', this.remark.remark || ''].join(',')
      let data = [{
        serviceItemGid: this.service.ServiceItemGid,
        serviceItemName: this.service.ServiceItemName,
        remark,
        skus: [{
          serviceItemSkuGid: this.service.Skus[0].ServiceItemSkuGid,
          serviceItemSkuName: this.service.Skus[0].ServiceItemSkuName,
          num: this.serviceNum
        }]
      }]
      updateOrderApi({ orderGid: this.gid, itemInfos: JSON.stringify(data), remark }).then(res => {
        if (res.code === 0) {
          this.$message.success('订单修改成功')
          this.$router.push("/orders/service")
        } else {
          this.$message.error(`订单修改失败:${res.des}`)
        }
      })
    },
    cancleEdit() {
      this.isEdit = false
      this.serviceNum = this.originNum
      this.remark.time = this.originTime
      this.remark.date = this.originDate
      this.remark.remark = this.originRemark
    },
    startService() {
      this.$confirm("确定开始服务？").then(() => {
        this.loading = true;
        this.Service.call(
          "housekeeping/start",
          "POST",
          qs.stringify({
            ordergid: this.order.gid
          }),
          null,
          null,
          null,
          "application/x-www-form-urlencoded"
        )
          .then(() => {
            this.$message.success("操作成功");
            this.loadData();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    endService() {
      this.$confirm("确定结束服务？").then(() => {
        this.loading = true;
        this.Service.call(
          "housekeeping/end",
          "POST",
          qs.stringify({
            ordergid: this.order.gid,
            pictures: "",
            remark: ""
          }),
          null,
          null,
          null,
          "application/x-www-form-urlencoded"
        )
          .then(() => {
            this.$message.success("操作成功");
            this.loadData();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    cancelOrder() {
      this.modal("OrderCancelModal", this.order).promise.then(rst => {
        if (rst === true) {
          this.loadData();
        }
      });
    },
    loadData() {
      if (!this.gid) {
        this.routeReplace("/orders/service");
        return;
      }
      this.loading = true;
      let order = {};
      this.Service.call("order/detail", "GET", { gid: this.gid })
        .then(data => {
          order = data || {};
          let task = [];
          let arr = (data.Remark || data.remark || "").split(",");
          this.remark = {
            date: arr[0] || "",
            time: arr[1] || "",
            addr: arr[2] || "",
            tel: arr[3] || "",
            remark: arr[4] || ""
          };
          task.push(
            this.Service.call("theold/detail", "GET", { gid: order.theOldGid })
              .then(data => {
                this.info = data || {};
              })
              .catch(() => { })
          );
          task.push(
            this.Service.call('theoldstatistics/account', 'GET', { theOldGid: order.theOldGid }).then(res => {
              this.olderMoney = { ...res }
            })
          )
          task.push(
            this.Service.call("usercontact", "GET", { gid: order.theOldGid })
              .then(data => {
                this.contacts = data || [];
              })
              .catch(() => { })
          );
          // let serviceId = order.servicePersonalGid
          // if (serviceId) {
          //   task.push(this.Service.call('serviceprovider/detail', 'GET', {gid: serviceId}).then(data => {
          //     this.service = data || {}
          //   }).catch(() => {}))
          // }
          Promise.all(task).finally(() => {
            try {
              order.serviceItemSkuInfos = JSON.parse(order.serviceItemSkuInfos);
              this.service = order.serviceItemSkuInfos[0];
              this.serviceNum = order.serviceItemSkuInfos[0].Skus[0].Num
              this.originNum = order.serviceItemSkuInfos[0].Skus[0].Num
              // let arr = (
              //   this.service.Remark ||
              //   this.service.remark ||
              //   ""
              // ).split(",");
              // this.remark = {
              //   date: arr[0] || "",
              //   time: arr[1] || "",
              //   addr: arr[2] || "",
              //   tel: arr[3] || "",
              //   remark: arr[4] || ""
              // };
              this.originDate = arr[0]
              this.originTime = arr[1]
              this.originRemark = arr[4] || ''
              this.order = order;
              Promise.all([
                this.Service.call("serviceprovider/detail", "GET", {
                  gid: this.order.serviceProviderGid
                })
                  .then(data => {
                    this.$set(this.order, "address", data.address);
                    this.$set(this.order, "cTelPhone", data.cTelPhone);
                  })
                  .catch(() => { }),
                this.Service.call("serviceitem/detail", "GET", {
                  gid:
                    this.service.gid ||
                    this.service.ServiceItemGid ||
                    this.service.serviceItemGid
                })
                  .then(data => {
                    this.$set(this.service, "unitOfTime", data.unitOfTime);
                    this.$set(
                      this.service,
                      "unitFrequencyTime",
                      data.unitFrequencyTime
                    );
                    this.$set(this.service, "cycle", data.cycle)
                    this.$set(this.service, "frequency", data.frequency)
                  })
                  .catch(() => { }),
                this.Service.call("orderrecord", "GET", {
                  index: 0,
                  size: 10,
                  orderGid: this.gid
                }).then(res => {
                  const result = {
                    data: res.data.map((item, suoyin) => ({
                      ...item,
                      abnormalFinish:
                        item.abnormalFinish === true ? "是" : "否",
                      abnormalFinishRemark: item.abnormalFinishRemark || "-",
                      num: res.index * res.size + suoyin + 1
                    })),
                    total: res.total,
                    pageSize: res.size,
                    currentPage: res.index + 1
                  };
                  this.allTableObj.dataList = result.data;
                  this.allTableObj.fenyeObj.total = result.total;
                  this.allTableObj.fenyeObj.currentPage = result.currentPage;
                  this.allTableObj.fenyeObj.pageSize = result.pageSize;
                })
              ]).finally(() => {
                this.loading = false;
              });
            } catch (e) {
              this.loading = false;
            }
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSizeChange(i, obj) {
      let reqObj = { index: 0, size: i };
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCurrentChange(i, obj) {
      reqObj = {
        index: i - 1,
        size: obj.fenyeObj.pageSize
      };
      this.pageSearchGet(reqObj);
    },
    pageSearchGet(reqObj) {
      this.Service.call("orderrecord", "GET", {
        ...reqObj,
        orderGid: this.gid
      }).then(res => {
        const result = {
          data: res.data.map((item, suoyin) => ({
            ...item,
            abnormalFinish: item.abnormalFinish === true ? "是" : "否",
            abnormalFinishRemark: item.abnormalFinishRemark || "-",
            num: res.index * res.size + suoyin + 1
          })),
          total: res.total,
          pageSize: res.size,
          currentPage: res.index + 1
        };
        this.allTableObj.dataList = result.data;
        this.allTableObj.fenyeObj.total = result.total;
        this.allTableObj.fenyeObj.currentPage = result.currentPage;
        this.allTableObj.fenyeObj.pageSize = result.pageSize;
      });
    },
    handleDetail(i, j) {
      this.oneRecordImgs = !j.servicePictures ? [] : j.servicePictures.split(',')
      this.showRecord = true;
      this.oneRecord = { ...j };
    },
    addAbnormal(i, j) {
      this.orderRecordGid = j.gid;
      this.showAddAbnormal = true;
    },
    saveAbnormal() {
      const reqObj = {
        gid: this.orderRecordGid,
        abnormalfinishremark: this.abnormalfinishremark
      };
      addOrderAbnormal(reqObj).then(res => {
        if (res.code === 0) {
          this.pageSearchGet({ index: 0, size: 10 });
          this.$message.success("异常处理添加成功");
          this.showAddAbnormal = false;
        } else {
          this.$message.error(`${res.des}`);
        }
      });
    }
  },
  watch: {
    serviceNum(i, j) {
      if (i != j) {
        this.addMoney = (parseInt(i - this.originNum) * this.service.Skus[0].Price)
      }

    },
    $route() {
      this.loadData();
    }
  }
};
</script>
<style lang="scss" scoped>
.avatar {
  width: 178px;
  height: auto;
  display: block;
}
.top-money-container {
  display: inline-block;
  border-left: 2px solid #909399;
  margin-left: 20px;
  .top-money {
    margin-left: 25px;
    color: black;
    .money-detail {
      font-weight: bold;
      font-size: 16px;
      color: #67c23a;
    }
  }
}
</style>

